<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="600px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title class="justify-space-between">
                <h1 class="text-subtitle-1">
                    Wybierz lokalizację
                </h1>
                <v-icon
                    v-if="hasCamera"
                    icon
                    color="primary"
                    class="hidden-md-and-up"
                    @click="showCodeReaderDialog"
                >
                    mdi-camera
                </v-icon>
            </v-card-title>

            <v-card-title>
                <v-autocomplete
                    v-model="selectedLocalization"
                    :items="filteredLocalizations"
                    :disabled="actionLoading"
                    :error-messages="selectedLocalizationErrors"
                    label="Lokalizacja"
                    item-text="name"
                    return-object
                    required
                    dense
                    filled
                />
            </v-card-title>

            <v-card-text class="v-card__text--no-padding">
                <v-data-table
                    :headers="tasksHeaders"
                    :items="tasks"
                    item-key="taskId"
                    hide-default-footer
                    disable-pagination
                    :mobile-breakpoint="0"
                    name="tasksData"
                />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zatwierdź"
                    :loading="actionLoading"
                    @click="onConfirm"
                >
                    Zatwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'LocalizationDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        localizations: {
            type: Array,
            default: null
        },
        tasks: {
            type: Array,
            default: null
        },
        qrCode: {
            type: Object,
            default: null
        },
        hasCamera: {
            type: Boolean
        },
    },
    data() {
        return {
            selectedLocalization: null,
            tasksHeaders: [
                {
                    text: 'Numer',
                    align: 'left',
                    sortable: false,
                    value: 'taskNumber'
                },
                {
                    text: 'Montaż',
                    align: 'left',
                    sortable: false,
                    value: 'plateNumber'
                }
            ],
            codeReaderSettings: {
                expectedQrTypeCodes: ['LOC'],
                origin: 'dialogCamera'
            },
            actionLoading: false
        }
    },
    validations() {
        return {
            selectedLocalization: {
                required
            }
        }
    },
    computed: {
        tasksPayload() {
            const array = []

            this.tasks.forEach(item => array.push(item.taskId))

            return array
        },
        filteredLocalizations() { // Without Buffer
            return this.localizations.filter(item => item.id !== 1)
        },
        // Walidacje
        selectedLocalizationErrors() {
            const errors = []

            if (!this.$v.selectedLocalization.$dirty) return errors
            !this.$v.selectedLocalization.required && errors.push('Proszę wybrać lokalizację.')

            return errors
        },
    },
    watch: {
        qrCode(qr) {
            if (this.codeReaderSettings.expectedQrTypeCodes.includes(qr.type)) {
                this.selectedLocalization = this.localizations.find(item => item.id === qr.locationId)
            }
        }
    },
    methods: {
        onConfirm() {
            this.$v.selectedLocalization.$touch()

            if (this.$v.selectedLocalization.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: 'Proszę wypełnić wymagane pola.'
                })

                return
            }

            this.actionLoading = true
            this.$store.dispatch('shipments/manageTracking/setTasksLocalization', {
                localizationWareNumbers: this.tasksPayload,
                localizationId: this.selectedLocalization.id
            })
                .then(() => {
                    this.onClose()
                    this.$emit('on-confirm', this.tasks)
                    this.$store.dispatch('showNotification', {
                        type: 'success',
                        message: `Odłożono w lokalizacji: "${this.selectedLocalization.name}".`
                    })
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        showCodeReaderDialog() {
            this.$emit('code-stream-start', this.codeReaderSettings)
        },
        onClose() {
            setTimeout(() => {
                this.selectedLocalization = null
            }, 500)
            this.$v.$reset()
            this.$emit('on-close')
        }
    }
}
</script>

